import { useState, useEffect } from 'react';
import { useContext } from 'react';
import { AuthContext } from '../contextStore/AuthContext';
import { getUserRef } from '../firebase/collections';

/**
 * Returns true if the current user has admin or moderator role.
 * Matches the same logic used by AdminRoute.
 */
export function useIsAdmin() {
  const { user } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!user?.uid) {
      setIsAdmin(false);
      return;
    }
    getUserRef(user.uid)
      .get()
      .then((doc) => {
        const role = doc.exists ? doc.data().role : null;
        setIsAdmin(role === 'admin' || role === 'moderator');
      })
      .catch(() => setIsAdmin(false));
  }, [user?.uid]);

  return isAdmin;
}
